import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const sideBarSlice = createSlice({
  name: 'sidebar',
  initialState: {
   tricker : null,
   manageMemberStep: 'manage_member',
   importModal: false,
   tabStep:'1'
  },
  reducers: {
   setTricker: (state, action) => {
    state.tricker = action.payload.tricker
   },
   setTabStepRedux: (state, action) => {
    state.tabStep = action.payload.tabStep
   },
   setManageMemberStep: (state, action) => {
    state.manageMemberStep = action.payload.manageMemberStep
   },
   setImportModal: (state, action) => {
    state.importModal = action.payload.importModal
   },
  },
})

export default sideBarSlice.reducer;

export const {
  setTricker,
  setManageMemberStep,
  setTabStepRedux,
  setImportModal
} = sideBarSlice.actions

export const getTricker = (state) => state.sidebar.tricker
export const getTabStep = (state) => state.sidebar.tabStep
export const getManageMemberStep = (state) => state.sidebar.manageMemberStep
export const getImportModal = (state) => state.sidebar.importModal